export class GcpOrganization {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementProjectId",
            "baseName": "managementProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementServiceAccountId",
            "baseName": "managementServiceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "AccountState",
            "format": ""
        },
        {
            "name": "excludeProjectPatterns",
            "baseName": "excludeProjectPatterns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "includeLabelFilters",
            "baseName": "includeLabelFilters",
            "type": "Array<GcpLabelFilter>",
            "format": ""
        },
        {
            "name": "excludeLabelFilters",
            "baseName": "excludeLabelFilters",
            "type": "Array<GcpLabelFilter>",
            "format": ""
        },
        {
            "name": "includeTagFilters",
            "baseName": "includeTagFilters",
            "type": "Array<GcpTagFilter>",
            "format": ""
        },
        {
            "name": "excludeTagFilters",
            "baseName": "excludeTagFilters",
            "type": "Array<GcpTagFilter>",
            "format": ""
        },
        {
            "name": "accountType",
            "baseName": "accountType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpOrganization.attributeTypeMap;
    }
    constructor() {
    }
}
